<template>
    <div class="modal-overlay">
        <div class="modal-content">
            <h3 class="text-center mb-4">تکمیل اطلاعات پروفایل</h3>
            <p class="text-muted text-center mb-5">
                لطفاً فرم زیر را پر کنید تا بتوانید از تمام امکانات استفاده کنید.
            </p>

            <form @submit.prevent="submitForm">
                <!-- نوع فعالیت -->
                <div class="form-group mb-3">
                    <label class="fw-bold mb-2">موضوع فعالیت</label>
                    <select v-model="form.jobType" class="form-control">
                        <option disabled value="">انتخاب کنید...</option>
                        <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                            {{ cat.name }}
                        </option>
                    </select>
                </div>

                <!-- نوع حساب -->
                <div class="form-group mb-3">
                    <label class="fw-bold mb-2">نوع حساب</label>
                    <div>
                        <label class="me-3">
                            <input type="radio" value="شخصی" v-model="form.accountType" />
                            شخصی
                        </label>
                        <label>
                            <input type="radio" value="سازمانی" v-model="form.accountType" />
                            سازمانی
                        </label>
                    </div>
                </div>

                <!-- مقصد -->
                <div class="form-group mb-3">
                    <label class="fw-bold mb-2">بیشترین استفاده شما از کدام مقصد است؟</label>
                    <select v-model="form.usageType" class="form-control">
                        <option disabled value="">انتخاب کنید...</option>
                        <option value="3">اینستاگرام</option>
                        <option value="4">یوتیوب</option>
                        <option value="6">توییچ</option>
                        <option value="7">آپارات</option>
                        <option value="13">تلگرام</option>
                        <option value="8">روبیکا</option>
                        <option value="9">سروش</option>
                        <option value="12">شاد</option>
                        <option value="15">ایتا</option>
                        <option value="11">ابرآروان</option>
                        <option value="50">پلیر اختصاصی</option>
                    </select>
                </div>

                <!-- نام و نام خانوادگی -->
                <div class="form-group mb-3">
                    <label class="fw-bold mb-2"> نام / نام سازمان</label>
                    <input type="text" class="form-control" v-model="form.firstName" placeholder="نام" />
                </div>

                <div class="form-group mb-3">
                    <label class="fw-bold mb-2">نام خانوادگی</label>
                    <input type="text" class="form-control" v-model="form.lastName" placeholder="نام خانوادگی" />
                </div>

                <!-- توضیحات -->
                <div class="form-group mb-4">
                    <label class="fw-bold mb-2">توضیحات و پیشنهادها برای بهبود سرویس</label>
                    <textarea class="form-control" rows="3" v-model="form.description"
                        placeholder="پیشنهادات شما..."></textarea>
                </div>

                <button type="submit" class="btn btn-primary w-100 py-2" :disabled="profileLoading">
                    <span v-if="!profileLoading">ثبت اطلاعات</span>
                    <span v-else>در حال ارسال...</span>
                </button>

                <p v-if="profileError" class="text-danger text-center mt-3">
                    {{ profileError }}
                </p>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { FETCH_CATEGORIES } from "@/core/services/store/user-category.module";
import { STORE_USER_PROFILE, VERIFY_USER } from "@/core/services/store/profile.module";
import Swal from "sweetalert2";

export default {
    name: "CompeleteProfileModal",

    data() {
        return {
            form: {
                jobType: "",
                accountType: "",
                usageType: "",
                firstName: "",
                lastName: "",
                description: ""
            }
        };
    },

    computed: {
        ...mapGetters(["categories", "categoriesLoading", "categoriesError", "profileLoading", "profileError"])
    },

    mounted() {
        if (!this.categories.length) {
            this.fetchCategories();
        }
    },

    methods: {
        ...mapActions({
            fetchCategories: FETCH_CATEGORIES,
            storeUserProfile: STORE_USER_PROFILE,
            verifyUser: VERIFY_USER,
        }),

        async submitForm() {
            try {
                const payload = {
                    category_id: this.form.jobType,
                    destination_type: this.form.usageType || null,
                    type: this.form.accountType === "شخصی" ? 1 : 2, // REAL:1 / COMPANY:2
                    first_name: this.form.firstName || null,
                    last_name: this.form.lastName || null,
                    description: this.form.description || null
                };

                await this.storeUserProfile(payload);
                Swal.fire({
                    title: "پروفایل با موفقیت ثبت شد",
                    text: "اکنون می‌توانید از تمامی امکانات پنل استفاده کنید.",
                    icon: "success",
                    confirmButtonText: "باشه",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-primary",
                    },
                });

                this.$emit("close");
                await this.verifyUser();
            } catch (error) {
                Swal.fire({
                    title: "خطا در ثبت اطلاعات",
                    text: error?.data?.message || "لطفاً دوباره تلاش کنید",
                    icon: "error",
                    confirmButtonText: "باشه",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                });
            } finally {
                this.submitting = false;
            }
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    backdrop-filter: blur(4px);
}

.modal-content {
    background: #fff;
    padding: 2rem 3rem;
    border-radius: 16px;
    width: 95%;
    max-width: 500px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.form-control {
    border-radius: 8px;
    padding: 0.6rem 0.75rem;
}
</style>
